export type RuleExitMode = "discard" | "leave";

/**
 * Whether leaving a rule surface needs a confirmation, and which one.
 *
 * Only unsaved work earns a prompt. A clean surface never blocks — not even a
 * rule Atlas is still building from the rail, which stays mounted across the
 * route change and loses nothing when the page behind it changes. A prompt on
 * a clean exit trains the merchant to click through it, which is the one
 * thing the dirty prompt cannot survive.
 */
export const resolveRuleExitMode = ({
  isDirty,
}: {
  isDirty: boolean;
}): RuleExitMode | null => (isDirty ? "discard" : null);
